var $25a3025fd66e8119$exports = {};
$25a3025fd66e8119$exports = {
    "collectionLabel": `F\xf6rslag`
};


export {$25a3025fd66e8119$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
